import React, { ComponentProps, useMemo } from 'react'

import { RemindersEditorReminderUnitValue } from '@surglogs-app/network'
import { Box, SelectLegacy } from '@surglogs-app/ui'

import { useTranslation } from '../services'

export const RemindersEditorListItemUnitSelect = (
  props: ComponentProps<typeof SelectLegacy>,
) => {
  const { t } = useTranslation()

  const data = useMemo(
    () => [
      {
        id: RemindersEditorReminderUnitValue.DAYS,
        text: t(`unitSelectOption.${RemindersEditorReminderUnitValue.DAYS}`),
      },
      {
        id: RemindersEditorReminderUnitValue.WEEKS,
        text: t(`unitSelectOption.${RemindersEditorReminderUnitValue.WEEKS}`),
      },
      {
        id: RemindersEditorReminderUnitValue.MONTHS,
        text: t(`unitSelectOption.${RemindersEditorReminderUnitValue.MONTHS}`),
      },
      {
        id: RemindersEditorReminderUnitValue.YEARS,
        text: t(`unitSelectOption.${RemindersEditorReminderUnitValue.YEARS}`),
      },
    ],
    [t],
  )

  return (
    <Box {...{ flex: 1 }}>
      <SelectLegacy
        {...{
          data,
          placeholder: t('reminderUnitSelectPlaceholder'),
          ...props,
        }}
      />
    </Box>
  )
}
